import React, {FC, useEffect} from 'react';
import clsx from 'clsx';
import {Button, CardContent, Container, Grid, makeStyles, Theme, Typography,} from '@material-ui/core';
import {Nav} from 'containers/common/sections/layout';
import RetailTheme from 'containers/retail/layouts/RetailTheme';
import {useRouter} from 'next/router';
import retailStores from 'stores/retail';
import {RetailSuccessCard} from 'components/retail/atoms';
import {observer} from 'mobx-react-lite';
import {AW_ID} from 'config/seo';
import {createGetServerSideProps} from "evcharging/app";
import {I18nPage} from "i18n/types/pages.enum";
import useI18n from "evcharging/hooks/useI18n";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
  },
  button: {
    maxWidth: theme.spacing(56),
    margin: theme.spacing(5, 0, 0),
    [theme.breakpoints.up('sm')]: {
      margin: theme.spacing(4, 0, 1.5),
      padding: theme.spacing(1.35, 1.25),
    },
    '&:hover': {
      backgroundColor: '#f9c206',
      borderColor: '#f9c206',
      color: '#fff',
    },
  },
  header: {
    margin: theme.spacing(0, 'auto', 3),
    color: '#000',
    fontSize: 18,
    lineHeight: '28px',
    [theme.breakpoints.up('sm')]: {
      fontSize: 20,
      lineHeight: 'normal',
      maxWidth: '100%',
    },
  },
  hint: {
    color: '#93979B',
    [theme.breakpoints.up('sm')]: {
      fontSize: 12,
    },
  },
  bodyText: {
    color: '#17192C',
  },
  customCardContent: {
    display: 'flex',
    justifyContent: 'center',
    '&:last-child': {
      paddingBottom: 40,
    },
    [theme.breakpoints.up('sm')]: {
      '&:last-child': {
        paddingBottom: 30,
      },
    },
  },
  textWrapper: {
    maxWidth: 390,
  },
  hintLink: {
    color: 'black',
  },
  cardWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: 'calc(100vh - 140px)',
    justifyContent: 'center',
    [theme.breakpoints.up('md')]: {
      '&:last-child': {
        height: 'calc(100vh - -140px)',
      },
    },
    [theme.breakpoints.up('lg')]: {
      '&:last-child': {
        height: 'calc(100vh - -120px)',
      },
    },
  },
}));

const ResidentialSuccessPage: FC = observer(() => {
  const classes = useStyles();
  const { push } = useRouter();
  const {
    residentialConfirmStore: { clearSession },
  } = retailStores;

  const onClose = () => push('/');

  useEffect(() => {
    clearSession();
    // @ts-ignore
    if (window.dataLayer) {
      // @ts-ignore
      window.dataLayer.push(['event', 'conversion', { send_to: AW_ID, transaction_id: '' }]);
    }
  }, []);

  const { t } = useI18n();

  return (
    <RetailTheme>
      <Nav />
      <Container>
        <Grid container spacing={4} justifyContent={'center'} className={classes.root}>
          <Grid item md={6} sm={12}>
            <div className={classes.cardWrapper}>
              <RetailSuccessCard>
                <CardContent className={classes.customCardContent}>
                  <div className={classes.textWrapper}>
                    <Typography variant={'h3'} className={classes.header}>
                      {t('retail.orderPlaced')}
                    </Typography>
                    <Typography className={classes.bodyText} variant={'body1'}>
                      {t('retail.willContactYou')}
                    </Typography>
                    <Button
                      fullWidth
                      variant="outlined"
                      color="primary"
                      className={clsx(classes.button)}
                      onClick={onClose}
                    >
                      {t('action.close')}
                    </Button>
                  </div>
                </CardContent>
              </RetailSuccessCard>
            </div>
          </Grid>
        </Grid>
      </Container>
    </RetailTheme>
  );
});

export const getServerSideProps = createGetServerSideProps(
  undefined,
  undefined,
  [I18nPage.RetailSuccess, I18nPage.RetailConfirmation]
);

export default ResidentialSuccessPage;
